interface CoverageItem {
  img: string;
  title: string;
  text: string;
}

interface CoverageCardsProps {
  title: string;
  // each entry renders on its own line
  subtitleLines: string[];
  items: CoverageItem[];
}

// 3 cards fill the row the same way 4 do in the design
const LG_COLUMNS: Record<number, string> = {
  3: "lg:tw-grid-cols-3",
  4: "lg:tw-grid-cols-4",
};

export default function CoverageCards({
  title,
  subtitleLines,
  items,
}: CoverageCardsProps) {
  return (
    <section className="tw-bg-[#0E0F12] tw-py-24">
      <div className="tw-max-w-[1120px] tw-mx-auto tw-px-6">
        {/* Heading */}
        <div className="tw-text-center tw-mb-14">
          <h2 className="tw-text-3xl md:tw-text-[40px] tw-font-semibold tw-text-white">
            {title}
          </h2>

          <p className="tw-mt-5 tw-text-sm md:tw-text-base tw-leading-relaxed tw-text-gray-400">
            {subtitleLines.map((line, i) => (
              <span key={line}>
                {i > 0 && <br />}
                {line}
              </span>
            ))}
          </p>
        </div>

        {/* Cards */}
        <div
          className={`tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 ${
            LG_COLUMNS[items.length] ?? LG_COLUMNS[4]
          } tw-gap-5`}
        >
          {items.map((item) => (
            <div
              key={item.title}
              className="tw-bg-[#1A1B1F] tw-border tw-border-[#2A2B30] tw-rounded-2xl tw-p-6"
            >
              <img
                src={item.img}
                alt={item.title}
                className="tw-w-[104px] tw-h-[104px] tw-object-cover tw-rounded-xl"
              />

              <h3 className="tw-mt-5 tw-text-lg tw-font-semibold tw-text-white">
                {item.title}
              </h3>

              <p className="tw-mt-4 tw-text-sm tw-leading-relaxed tw-text-gray-400">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
